import React from 'react'

import { useAuth } from '@cooltrax/jellyfish-sdk'
import { Outlet } from 'react-router-dom'

import { JellyfishTopbar } from '@client/components/JellyfishTopbar'
import { Footer } from '@cooltrax/jellyfish-ui'

const Layout: React.FC = () => {
  const { user, isAuthenticated } = useAuth()
  // const { shouldOpenSidebar, setShouldOpenSidebar, sidebarMobileButtonRef } = useSidebarMobile()

  return (
    <div className="flex flex-col h-screen">
      <JellyfishTopbar user={user} isAuthenticated={isAuthenticated} />
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Layout
